import { getContentTypeResponse } from '@/lib/util';
import baseApi from '@/modules/services/base';
import {
  CourseLibraryDownloadResultTag,
  CourseLibraryTag,
  MyElearningTag,
  VideoLibraryTag,
} from '@/modules/services/tags';
import {
  CourseLibraryDownloadV2Response,
  CourseLibraryViewData,
  LibraryElearningsDataType,
  LibraryQueryInterface,
} from '@/pages/CourseLibrary/types';
import { PaginationType } from '../types/elearning';

const courseLibraryApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getLibraryElearnings: build.query<
      LibraryElearningsDataType,
      void | LibraryQueryInterface
    >({
      query: (params: LibraryQueryInterface) =>
        params
          ? {
              url: `elearning-library/list`,
              params,
            }
          : { url: `elearning-library/list` },
      providesTags: [CourseLibraryTag],
    }),
    getLibraryElearningV2: build.query<
      PaginationType<CourseLibraryViewData>,
      void | LibraryQueryInterface
    >({
      query: (params: LibraryQueryInterface) =>
        params
          ? {
              url: `elearning-library/course-library`,
              params,
            }
          : { url: `elearning-library/course-library` },
      providesTags: [CourseLibraryTag],
    }),
    downloadLibraryV2: build.mutation<CourseLibraryDownloadV2Response, string>({
      query: (elearningId) => ({
        url: `elearning-library/course-library/${elearningId}/download`,
        method: 'POST',
        validateStatus: (response) =>
          response.status === 200 || response.status === 201,
        responseHandler: getContentTypeResponse,
      }),
      invalidatesTags: [
        CourseLibraryDownloadResultTag,
        MyElearningTag,
        CourseLibraryTag,
        VideoLibraryTag,
      ],
    }),
    getDownloadCourseResult: build.query<boolean, string>({
      query: (elearningId) => ({
        url: `/elearning-library/check-download-completed/${elearningId}`,
      }),
      providesTags: [CourseLibraryDownloadResultTag],
    }),
    startDownloadCourse: build.mutation<any, string>({
      query: (elearningId) => ({
        url: `/elearning-library/download`,
        method: 'POST',
        body: {
          courseId: +elearningId,
        },
        validateStatus: (response) =>
          response.status === 200 || response.status === 201,
        responseHandler: getContentTypeResponse,
      }),
      invalidatesTags: [CourseLibraryDownloadResultTag, MyElearningTag],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetLibraryElearningsQuery,
  useGetLibraryElearningV2Query,
  useDownloadLibraryV2Mutation,
  useGetDownloadCourseResultQuery,
  useStartDownloadCourseMutation,
} = courseLibraryApi;

export default courseLibraryApi;
